/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { pluralize } from 'helpers/formatters'

import { Panel } from './components/Panel'

import s from './CollectionsCard.module.css'

export function CollectionsCard({ collection, fetchCollections, isOwner }) {
  const { cover_photo_url, name, listing_ids, id, shared_with_contacts, archived } = collection
  const [showPanel, setShowPanel] = useState(false)

  useEffect(() => {
    const close = (e) => {
      if (e.key === 'Escape') {
        setShowPanel(false)
      }
    }
    document.addEventListener('keyup', close)
    return () => document.removeEventListener('keyup', close)
  }, [])

  const clientsNumber = shared_with_contacts && shared_with_contacts.length

  return (
    <div className={s.root}>
      <a href={`/listing_collections/${id}`} className={s.image}>
        <img src={cover_photo_url} className={s.imageElem} alt={name} />
      </a>

      <div className={s.panel}>
        <div className={s.header}>
          <a href={`/listing_collections/${id}`} className={s.title}>
            {name}
          </a>
          {isOwner && (
            <div
              className={s.control}
              onClick={(e) => {
                e.stopPropagation()
                setShowPanel((isOpen) => !isOpen)
              }}
            >
              <div className={s.bigDot} />
              <div className={s.bigDot} />
              <div className={s.bigDot} />
            </div>
          )}

          {showPanel && (
            <Panel archived={archived} id={id} afterDelete={fetchCollections} onClose={() => setShowPanel(false)} />
          )}
        </div>

        <div className={s.main}>
          {listing_ids && <div className={s.units}>{pluralize(listing_ids.length, 'Unit', 'Units')}</div>}

          {shared_with_contacts && (
            <>
              <div className={s.smallDot} />
              <div className={s.clients}>{pluralize(clientsNumber, 'Client', 'Clients')}</div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

CollectionsCard.propTypes = {
  collection: PropTypes.shape({
    id: PropTypes.number.isRequired,
    cover_photo_url: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    description: PropTypes.string,
    homepage_feature: PropTypes.bool.isRequired,
    listing_ids: PropTypes.arrayOf(PropTypes.number),
    name: PropTypes.string.isRequired,
    updated_at: PropTypes.string.isRequired,
  }),
  client_email: PropTypes.string,
  client_phone: PropTypes.string,
  description: PropTypes.string,
  fetchCollections: PropTypes.func,
}

CollectionsCard.defaultProps = {
  collection: {
    description: '',
    listing_ids: [],
  },
  client_email: '',
  client_phone: '',
  description: '',
}
